import extensibilityState from './store';
import ExtensibilityState from './schema/ExtensibilityState';

export default function getExtensibilityState(): ExtensibilityState {
    return extensibilityState;
}
